module.exports = __webpack_public_path__ + "static/img/login-bg.48ceea3d.png";